<template>
<v-scale-transition>
    <div class="nav-item" :style="outerStyle" :class="{indented}">
        <v-list-item v-show="show" :to="editable ? null : appRef.route" dark :dense="indented" >
            <!-- <v-avatar><v-icon>{{appRef.icon}}</v-icon></v-avatar> -->
            <v-list-item-icon class="main-icon">
                <!-- <v-badge color="red" bottom icon="mdi-comment-text" overlap :value="true"> -->
                <v-icon :size="indented ? 18 : null">{{appRef.icon}}</v-icon>
                <!-- </v-badge> -->
            </v-list-item-icon>
            <v-list-item-content :class="{'angle-shake': editable, indented}">
                <!-- <v-list-item-title>{{appRef.name}}</v-list-item-title> -->
                <h4 class="condensed-text">{{appRef.name}}</h4>
            </v-list-item-content>
            <v-list-item-action v-if="editable">
                <v-btn icon small @click.stop="$emit('remove', appRef)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-list-item-action>
        </v-list-item>
        <slot></slot>
    </div>
</v-scale-transition>
</template>

<script>
import userSettings from "@/_mixins/user-settings-mixin"
import colors from 'vuetify/lib/util/colors'

export default {
    mixins: [userSettings],
    name: 'AppNavItem',

    props: {
        appRef: {
            type: Object,
            default: () => null
        },
        editable: {
            type: Boolean,
            default: false
        },
        animate: {
            type: Boolean,
            default: false
        },
        indented : {
            type:Boolean,
            default:false,
        }
    },
    created() {},
    mounted() {
        // debugger;
        // setTimeout(() => this.show = true, 0);
        this.show = true;
    },
    destroy() {

    },
    computed: {
        outerStyle() {
            if (this.appRef.color) {

//                 debugger;
//                 var thisColors = this.appRef.color.split(" ").filter(e => !!e);
//                 var shade = thisColors.length > 1 ? thisColors[1] : "base";
// debugger;
//                 var accentColor = this.colors[thisColors[0]][thisColors.length > 1 ? thisColors[1].replace("-","") : "base"];
//                 debugger;
                return {
                    borderLeft : "6px transparent solid",
                    borderLeftColor:this.appRef.color,
                }
            }
            // return "transparent"
        }
    },
    data() {
        return {
            colors: colors,
            show: !this.animate,
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
h4 {
    font-weight: normal;
}

.main-icon {
    margin-right: 18px !important;
}
.indented
{
    zoom:.90;
    // padding-left:10px !important;
}
</style>
